<span [class.smaller]="rank > 99">{{rank}}</span>